import { useQuery } from '@apollo/react-hooks';
import OriginTracing from '@atlassiansox/origin-tracing';

import { useSessionData } from '@confluence/session-data';
import { getAGGClient } from '@confluence/graphql';

import { OSBUrlQuery } from '../queries/OSBUrl.agggraphql';
import { OFFERING_KEY, statsigCohorts } from '../experimentConstants';
import { useExperimentInfo } from '../store/experimentInfoStore';

import { useHandleHookStates, OSB } from './useHandleHookStates';

export const useGetOSBLink = () => {
	const { cloudId } = useSessionData();
	const { cohort } = useExperimentInfo();

	const { data, error, loading } = useQuery(
		// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
		OSBUrlQuery,
		{
			client: getAGGClient(),
			variables: {
				cloudId,
				productKey: 'confluence.ondemand',
				offeringKey: OFFERING_KEY,
			},
			skip: cohort !== statsigCohorts.TREATMENT,
		},
	);

	useHandleHookStates({
		loading,
		error,
		hook: OSB,
	});

	const createCompleteOsbLink = () => {
		const osbLink =
			data?.tenantContexts[0]?.entitlementInfo?.entitlement?.subscription?.accountDetails
				?.invoiceGroup?.experienceCapabilities?.configurePayment?.experienceUrl;
		const paymentScreenLink =
			data?.tenantContexts[0]?.entitlementInfo?.entitlement?.transactionAccount
				?.experienceCapabilities?.addPaymentMethod?.experienceUrl;

		const linkThatWorks = osbLink || paymentScreenLink;

		const origin = new OriginTracing({ product: 'confluence' });
		return origin.addToUrl(linkThatWorks);
	};

	return {
		osbLink: createCompleteOsbLink(),
		error,
		loading,
	};
};
